<template>
  <el-dialog
    :visible.sync="isVisible"
    title="腾讯云手机桌面"
    :width="dialogWidth"
    :close-on-click-modal="false"
    append-to-body
    destroy-on-close
    @close="isVisible = false"
  >
    <div
      v-loading="loading"
      element-loading-text="正在建立连接..."
      element-loading-spinner="el-icon-loading"
      style="position: relative; min-height: 200px"
    >
      <div v-show="!loading" class="video-container">
        <video
          id="player"
          ref="videoPlayer"
          autoplay
          :width="videoSize.w"
          :height="videoSize.h"
        />
      </div>
      <div v-show="!loading" class="controls">
        <el-button-group>
          <el-button size="mini" @click="handleRoutine(187)">---</el-button>
          <el-button size="mini" @click="handleRoutine(3)">首页</el-button>
          <el-button size="mini" @click="handleRoutine(4)">返回</el-button>
          <el-button size="mini" @click="handleRoutine(24)">音量+</el-button>
          <el-button size="mini" @click="handleRoutine(25)">音量-</el-button>
        </el-button-group>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getTencentToken } from '@/api/enterprisewechatControl'

export default {
  name: 'TencentCloudMobileDialog',
  props: {
    visible: { type: Boolean, required: true },
    connectionParams: { type: Object, required: true },
    videoSize: { type: Object, default: () => ({ w: 288, h: 640 }) }
  },
  data() {
    return {
      isVisible: false,
      loading: false,
      connected: false,
      videoWs: null,
      orderWs: null,
      heartbeat: null,
      jmuxer: null,
      screenWidth: window.innerWidth
    }
  },
  computed: {
    dialogWidth() {
      return this.screenWidth < 768 ? '90vw' : '400px'
    }
  },
  watch: {
    visible(v) {
      this.isVisible = v
    },
    isVisible(v) {
      this.$emit('update:visible', v)
      v ? this.startConnect() : this.teardown()
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth)
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth
    },
    async startConnect() {
      if (this.connected || this.loading) return
      this.loading = true
      try {
        const { sn } = this.connectionParams
        const res = await getTencentToken({ sn })
        const { video_ip, order_port, token_key } = res.data
        if (!video_ip || !order_port || !token_key) {
          throw new Error('接口返回参数不完整')
        }

        // 确保 <video id="player"> 已经渲染
        await this.$nextTick()

        // 1) 初始化 JMuxer
        this.jmuxer = new window.JMuxer({
          node: 'player',
          flushingTime: 15,
          fps: 30,
          mode: 'video'
        })

        // 2) init_video
        window.webSocket.init_video({
          videoIP: video_ip,
          sn,
          jmuxer: this.jmuxer,
          myVideo: this.$refs.videoPlayer,
          token: token_key,
          onopen_videoWs: () => {
            this.videoWs = window.videoWs
            // 心跳保活
            this.heartbeat = setInterval(() => {
              if (this.videoWs.readyState === WebSocket.OPEN) {
                this.videoWs.send(1)
              }
            }, 3000)
          }
        })

        // 3) init_order
        window.webSocket.init_order({
          orderIP: order_port,
          sn,
          clientId: 3,
          busType: 1,
          token: token_key,
          myVideo: this.$refs.videoPlayer,
          VIDEO_WIDTH: this.videoSize.w,
          VIDEO_HEIGHT: this.videoSize.h,
          WIDTH: 1080,
          HEIGHT: 2400,
          onopen_orderWs: () => {
            this.orderWs = window.orderWs
            // 默认清晰度
            window.webSocket.send_videoWs(window.ExexutePixel(6, sn))
          }
        })

        this.connected = true
      } catch (err) {
        console.error('连接腾讯云手机失败', err)
        this.$message.error('连接失败，请重试')
        this.isVisible = false
      } finally {
        this.loading = false
      }
    },

    teardown() {
      // 关闭 WS
      if (this.videoWs) this.videoWs.close()
      if (this.orderWs) this.orderWs.close()
      clearInterval(this.heartbeat)

      // 销毁 JMuxer
      this.jmuxer?.destroy()

      // 重置 <video>
      const v = this.$refs.videoPlayer
      if (v) {
        v.pause()
        v.removeAttribute('src')
        v.load()
      }

      this.connected = false
    },

    handleRoutine(code) {
      if (this.orderWs?.readyState === WebSocket.OPEN) {
        window.webSocket.send_orderWs(
          window.ExexuteKeyDown(code, this.connectionParams.sn)
        )
      }
    }

  }
}
</script>

<style scoped>
.video-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.controls {
  text-align: center;
  margin-top: 10px;
}
video {
  display: inline-block;
  height: 100%;
}
</style>
